import {
  ActionTypeModel,
  CustomActionRecordModel,
  RealTimeBookingRecordModel,
  CallTransferRecordModel,
} from "@/api/models";
import {FlowNodeSetting} from "@/types/node";
import {actionNodeBlueprint} from "@/pages/flow/NodeTypes/Blueprints/action";
import {bookingNodeBlueprint} from "@/pages/flow/NodeTypes/Blueprints/booking";
import {transferNodeBlueprint} from "@/pages/flow/NodeTypes/Blueprints/transfer";
import {processNodes} from "@/contexts/SaveContext";
import {createNode} from "@/pages/flow/NodeTypes/FlowNode";
import {restoreNodeSettings} from "..";
import {Node} from "@xyflow/react";
import {FlowNodeData, ProcessedNode} from "@/types/node";

const actionBlueprintMapping = {
  [ActionTypeModel.CUSTOM]: actionNodeBlueprint,
  [ActionTypeModel.BOOKING]: bookingNodeBlueprint,
  [ActionTypeModel.TRANSFER]: transferNodeBlueprint,
};

export const generateNodeSettingsFromAction = (
  action:
    | CustomActionRecordModel["nodeData"]
    | RealTimeBookingRecordModel["nodeData"]
    | CallTransferRecordModel["nodeData"],
  actionType: ActionTypeModel,
): FlowNodeSetting[] => {
  const actionBlueprint = actionBlueprintMapping[actionType];
  const actionNode = createNode(actionBlueprint) as Node<FlowNodeData>;
  const processedActionNode = processNodes([
    actionNode,
  ])[0] as unknown as ProcessedNode;
  processedActionNode.data.settings = action;
  const restoredNode = restoreNodeSettings([
    processedActionNode as unknown as Node<FlowNodeData>,
  ]);
  return restoredNode[0].data.settings;
};
